<template>
  <div class="mt-10">
    <div class="subheader py-3 py-lg-3 subheader-transparent transparent">
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
          container-fluid
          p-0
        "
      >
        <div class="d-flex align-items-baseline mr-5 mb-5">
          <h3 class="subheader-title text-dark font-weight-bold my-2 mr-3">
            Capaian berdasarkan daerah
          </h3>
        </div>
        <div class="d-flex align-items-center">
          <div class="d-flex flex-wrap">
            <ToggleSwitch2
              :options="switchOptions2"
              :value="selectedToggle2"
              @change="updateToggle2($event.value)"
              class="mt-2"
            />
            <Multiselect
              v-if="isRegionReady"
              class="select ml-md-5"
              :value="selectedRegion"
              :options="provinceOptions"
              :custom-label="nameWithLang"
              @input="updateSelectedRegion"
              @select="onSelect"
              placeholder="Select one"
              label="name"
              track-by="name"
              deselectLabel="x"
              selectLabel=""
            />
          </div>
        </div>
      </div>
    </div>

    <BarChart
      v-if="displaydatacollection"
      :chartData="displaydatacollection"
      :styles="myStyles"
      :fontSize="fontSize"
      :color="color"
    />

    <!-- <pre class="language-json"><code>{{ displaydatacollection }}</code></pre> -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import BarChart from '@/view/components/charts/BarChart'
import ToggleSwitch2 from 'vuejs-toggle-switch'

// select region
import Multiselect from 'vue-multiselect'

export default {
  name: 'chart',
  components: {
    BarChart,
    ToggleSwitch2, // toggle
    Multiselect, // select region
  },
  data() {
    return {
      height: 600,
      fontSize: '9',
      color: '#252827',

      selectedToggle2: 'Dosis satu', // toggle
      switchOptions2: {
        layout: {
          color: '#3699ff',
          backgroundColor: 'white',
          selectedColor: 'white',
          selectedBackgroundColor: 'green',
          borderColor: '#3699ff',
          fontFamily: 'Arial',
          fontWeight: 'normal',
          fontWeightSelected: 'normal',
          squareCorners: false,
          noBorder: false,
        },
        size: {
          fontSize: 1,
          height: 2.5,
          width: 25,
        },
        items: {
          delay: 0.4,
          preSelected: 'unknown',
          disabled: false,
          labels: [
            { name: 'Dosis satu', color: 'white', backgroundColor: '#3699ff' },
            {
              name: 'Dosis dua',
              color: 'white',
              backgroundColor: '#3699ff',
            },
            {
              name: 'Dosis tiga',
              color: 'white',
              backgroundColor: '#3699ff',
            },
          ],
        },
      },
    }
  },
  methods: {
    ...mapActions(['updateSelectedRegion']),
    getCharData() {
      if (this.vaccinesreport.isReady) {
        let arrData = null
        if (this.selectedToggle2 == 'Dosis satu') {
          arrData =
            this.selectedRegion.region_id === '1'
              ? this.getDoseOneProvince
              : this.getDoseOneDistrict
        }

        if (this.selectedToggle2 == 'Dosis dua') {
          arrData =
            this.selectedRegion.region_id === '1'
              ? this.getDoseTwoProvince
              : this.getDoseTwoDistrict
        }

        if (this.selectedToggle2 == 'Dosis tiga') {
          arrData =
            this.selectedRegion.region_id === '1'
              ? this.getDoseThreeProvince
              : this.getDoseThreeDistrict
        }

        // filter data if KaKo is selected
        if (this.selectedRegion.region_id !== '1') {
          arrData = arrData.filter((item) => {
            return item.id_provinsi === this.selectedRegion.region_id
          })
        }

        const chartData = arrData.map((item) => {
          return {
            name:
              this.selectedRegion.region_id === '1'
                ? item.provinsi
                : item.kabupaten,
            // region_id: item.id_provinsi,
            value: item.capaian_harian,
            target: item.total_sasaran,
          }
        })
        // sort by completed
        chartData.sort(function (a, b) {
          return b.value - a.value
        })

        return chartData
      }
    },
    // toggle for dose
    updateToggle2($event) {
      this.selectedToggle2 = $event
    },

    // select region
    nameWithLang({ name }) {
      return `${name}`
    },
    // select region
    onSelect(option) {
      console.log(option)
    },
  },
  computed: {
    ...mapGetters([
      'getDoseOneProvince',
      'getDoseTwoProvince',
      'getDoseThreeProvince',
      'getDoseOneDistrict',
      'getDoseTwoDistrict',
      'getDoseThreeDistrict',
      'isRegionReady',
      'provinceOptions',
      'selectedRegion',
    ]),
    ...mapState(['vaccinesreport']),

    // calling entry function
    displaydatacollection() {
      if (this.vaccinesreport.isReady) {
        const chartLabels = this.getCharData().map((item) => item.name)
        const value = this.getCharData().map((item) => item.value)

        const total = this.getCharData().map((item) => {
          return {
            val: item.value,
            target: item.target,
          }
        })

        return {
          labels: chartLabels,
          datasets: [
            {
              label: 'Capaian',
              backgroundColor: '#e7d090',
              data: value,
              total: total,
            },
          ],
        }
        // return this.buildChart()
      }
      return false
    },
    // barchart height
    myStyles() {
      return {
        height: `${this.height}px`,
      }
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
/* select region */
.multiselect__tags {
  min-height: 38px;
  display: block;
  padding: 5px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
.select {
  width: 250px;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 14px;
  margin-top: 3px;
}
</style>
